module.exports = __webpack_public_path__ + "img/square_v1.4dc40b9b.png";